<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> NOTAS CONCILIADAS </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="3">
              <v-autocomplete
                :items="companies_providers"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="filters.provider"
                label="Fornecedores"
                multiple
                small-chips
                hide-details
                clearable
                dense
                outlined
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip small v-if="index === 0">
                    <span
                      >{{ item.code }} -
                      {{ item.name.substring(0, 25) }}...</span
                    >
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ filters.provider.length - 1 }} outros)
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-autocomplete
                :items="companies"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="filters.franchise"
                label="Franqueados"
                ref="franchise"
                multiple
                small-chips
                hide-details
                clearable
                dense
                outlined
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip small v-if="index === 0">
                    <span
                      >{{ item.code }} -
                      {{ item.name.substring(0, 15) }}...</span
                    >
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ filters.franchise.length - 1 }} outros)
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-text-field
                outlined
                dense
                hide-details
                v-mask="dateMask"
                v-model="filters.startDate"
                ref="start_date"
                class="fs-12"
                label="Periodo"
                append-outer-icon="mdi-calendar"
                @click:append-outer="handleClickCalendar('startDate')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-text-field
                outlined
                dense
                hide-details
                v-mask="dateMask"
                v-model="filters.endDate"
                ref="end_date"
                class="fs-12"
                label="Até"
                append-outer-icon="mdi-calendar"
                @click:append-outer="handleClickCalendar('endDate')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-1"
                @click="getInvoices()"
              >
                Executar Consulta
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                :disabled="invoices.length == 0"
                @click="printInvoice('pdf', 'analitico', invoices)"
                color="grey darken-4"
                outlined
                small
                class="mt-1 mr-1"
              >
                <v-icon color="red" left> mdi-file-pdf-box </v-icon>
                PDF
              </v-btn>
              <v-btn
                :disabled="invoices.length == 0"
                @click="printInvoice('excel', 'analitico', invoices)"
                color="grey darken-4"
                outlined
                small
                class="mt-1"
              >
                <v-icon color="green" left> mdi-file-excel-box </v-icon>
                Excel
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-simple-table dense fixed-header height="380">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th
                                class="text-left fs-12 text-no-wrap"
                                width="15%"
                              >
                                Fornecedor
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Total Notas
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Total Produtos
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Qtde. Geral
                              </th>
                              <th class="text-center fs-12 text-no-wrap">
                                Nota Inicial
                              </th>
                              <th class="text-center fs-12 text-no-wrap">
                                Nota Final
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Imprimir
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="invoice in invoices" :key="invoice.id">
                              <td class="text-left fs-12 text-no-wrap">
                                {{ invoice.provider.code }} -
                                {{ invoice.provider.name }}
                              </td>
                              <td class="text-right fs-12 text-no-wrap">
                                {{ invoice.value_total | currencyEuaToBr }}
                              </td>
                              <td class="text-right fs-12 text-no-wrap">
                                {{ invoice.value | currencyEuaToBr }}
                              </td>
                              <td class="text-right fs-12 text-no-wrap">
                                {{ invoice.quantity }}
                              </td>
                              <td class="text-center fs-12 text-no-wrap">
                                {{ getNoteMin(invoice) }}
                              </td>
                              <td class="text-center fs-12 text-no-wrap">
                                {{ getNoteMax(invoice) }}
                              </td>
                              <td class="text-right fs-12 text-no-wrap">
                                <v-btn
                                  @click="
                                    printInvoice('pdf', 'analitico', invoice)
                                  "
                                  color="grey darken-4"
                                  outlined
                                  small
                                  class="mt-1 mr-2"
                                >
                                  <v-icon color="red darken-1"
                                    >mdi-file-pdf-box</v-icon
                                  >
                                </v-btn>
                                <v-btn
                                  @click="
                                    printInvoice('excel', 'analitico', invoice)
                                  "
                                  color="grey darken-4"
                                  outlined
                                  small
                                  class="mt-1"
                                >
                                  <v-icon color="green darken-1"
                                    >mdi-file-excel-box</v-icon
                                  >
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot v-if="invoices.length > 0">
                            <tr>
                              <th>Total Geral:</th>
                              <th class="text-right fs-12 text-no-wrap">
                                {{
                                  invoices.reduce(
                                    (prev, curr) =>
                                      prev + parseFloat(curr.value_total),
                                    0
                                  ) | currencyEuaToBr
                                }}
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                {{
                                  invoices.reduce(
                                    (prev, curr) =>
                                      prev + parseFloat(curr.value),
                                    0
                                  ) | currencyEuaToBr
                                }}
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                {{
                                  invoices.reduce(
                                    (prev, curr) =>
                                      prev + parseInt(curr.quantity),
                                    0
                                  )
                                }}
                              </th>
                              <th></th>
                              <th></th>
                              <th></th>
                            </tr>
                          </tfoot>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="linkDownload"
    >
      <v-card>
        <v-card-text class="pa-10">
          <v-btn
            class="ma-5 white--text justify-center d-flex"
            large
            color="indigo"
            target="_blank"
            :href="download.link"
            @click="() => (linkDownload = false)"
          >
            <v-icon left>mdi-cloud-download</v-icon>
            CLIQUE AQUI PARA BAIXAR
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="linkDownload = false">
            FECHAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      ref="dialog"
      v-model="modalDate"
      :return-value.sync="dateDialog"
      width="290px"
    >
      <v-date-picker
        v-model="dateDialog"
        scrollable
        no-title
        @change="handlePickerDate"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modalDate = false"> Fechar </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";
import AwesomeMask from "awesome-mask";

import * as CompanyAPI from "@/api/requests/CompanyRequest";

import Alert from "@/components/Alert";

export default {
  components: { Alert },
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    dateMask: "99/99/9999",
    companies: [],
    companies_providers: [],
    providerTypes: [],
    provider: "",
    franchise: "",
    provider_type_id: "",
    start_date: "",
    end_date: "",
    months: [
      { value: 1, text: "Janeiro" },
      { value: 2, text: "Fevereiro" },
      { value: 3, text: "Março" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Maio" },
      { value: 6, text: "Junho" },
      { value: 7, text: "Julho" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Setembro" },
      { value: 10, text: "Outubro" },
      { value: 11, text: "Novembro" },
      { value: 12, text: "Dezembro" },
    ],
    month: "",
    years: [],
    year: "",
    loading: false,
    successSave: false,
    lazy: false,
    valid: true,
    invoices: [],
    showAlert: false,
    typeAlert: "error",
    messageAlert: "",
    linkDownload: false,
    download: {
      name: "",
      link: "#",
    },
    filters: {
      provider: [],
      franchise: [],
      // providerType: "",
      startDate: "",
      endDate: "",
      // month: "",
      // year: "",
    },
    dateDialog: "",
    modalDate: false,
    editFieldDate: "",
  }),
  computed: {},
  created() {
    let dateNow = new Date();
    let lastDayOfMonth = new Date(dateNow.getFullYear(), dateNow.getMonth(), 0);
    let month = dateNow.getMonth();
    // this.year = dateNow.getFullYear();
    let yearNow = dateNow.getFullYear();

    month = month.toString().padStart(2, 0);

    this.filters.startDate = `01/${month}/${yearNow}`;
    // this.filters.startDate = `01/11/${yearNow}`;
    this.filters.endDate = `${lastDayOfMonth
      .getDate()
      .toString()
      .padStart(2, 0)}/${month}/${yearNow}`;

    // COLOCA 10 ANOS PARA TRAS
    for (let i = 10; i >= 0; i--) {
      this.years.push(yearNow - i);
    }
    this.years = this.years.reverse();
    this.initialize();
  },
  methods: {
    async initialize() {
      this.getCompanies();
      // await this.getInvoices();
    },
    validate() {},
    async getCompanies() {
      // this.loading = true;
      try {
        let data = await CompanyAPI.getAll();
        this.companies = data
          .filter((item) => item.type === "fra" || item.type === "mul")
          .sort((a, b) => (a.name > b.name ? 1 : -1));
        this.companies_providers = data
          .filter((item) => item.type === "for")
          .sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.companies = [];
        console.log(error);
      } finally {
        // this.loading = false;
      }
    },
    async getInvoices() {
      let isValid = false;
      isValid = Object.keys(this.filters).filter(
        (key) => this.filters[key] !== null && this.filters[key] !== ""
      );

      if (isValid.length === 0) {
        this.messageAlert =
          "Preencha pelo menos um campo dos filtros para poder buscar as notas conciliadas";
        this.typeAlert = "error";
        this.showAlert = true;
        return;
      }

      this.showAlert = false;
      this.loading = true;
      this.invoices = [];
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });

        let response = await fetch(`${URL}invoice/report`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({
            ...this.filters,
            endDate: this.dateToEua(this.filters.endDate),
            startDate: this.dateToEua(this.filters.startDate),
          }),
        });
        let res = await response.json();
        let providersCode = [
          ...new Set(res.map((item) => item.provider_id)),
        ].sort((a, b) => (a > b ? 1 : -1));

        let dataInvoices = providersCode.map((provId) => {
          let reg = res.filter((item) => item.provider_id === provId);
          let orders = [];
          let invoices = reg.map((item) => item.id);
          reg.map((item) => item.orders.map((ord) => orders.push(ord)));
          return {
            provider_id: reg[0].provider_id,
            provider: reg[0].provider,
            numbers: reg.map((item) => item.number),
            value: reg.reduce((prev, curr) => prev + parseFloat(curr.value), 0),
            value_total: reg.reduce(
              (prev, curr) =>
                prev +
                (parseFloat(curr.value_total) == 0
                  ? parseFloat(curr.value)
                  : parseFloat(curr.value_total)),
              0
            ),
            quantity: reg.reduce(
              (prev, curr) => prev + parseInt(curr.quantity),
              0
            ),
            orders: orders,
            invoices: invoices,
          };
        });

        this.invoices = dataInvoices.sort((a, b) =>
          a.provider.code > b.provider.code ? 1 : -1
        );
        // this.invoices = res;
      } catch (error) {
        console.log(error);
        this.messageAlert =
          "Não foi possível carregar as notas conciliadas, tente novamente mais tarde";
        this.typeAlert = "error";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
    dateToBr(date) {
      if (date == "") return;
      return date.split("-").reverse().join("/");
    },
    dateToEua(date) {
      if (date == undefined) return "";
      return date.split("/").reverse().join("-");
    },
    datetimeToBr(datetime) {
      if (datetime == "") return;
      let [date, time] = datetime.split(" ");
      return `${date.split("-").reverse().join("/")} ${time}`;
    },
    handleClickCalendar(field) {
      this.editFieldDate = field;
      this.dateDialog = this.dateToEua(this.filters[field]);
      this.modalDate = true;
    },
    handlePickerDate() {
      this.modalDate = false;
      this.filters[this.editFieldDate] = this.dateToBr(this.dateDialog);
    },
    async printInvoice(format, type, data = {}) {
      console.log(data);
      let body = {
        ...this.filters,
        endDate: this.dateToEua(this.filters.endDate),
        startDate: this.dateToEua(this.filters.startDate),
      };
      if (type === "analitico") {
        body = { data: !Array.isArray(data) ? [data] : data };
      }
      body.startDate = this.filters.startDate;
      body.endDate = this.filters.endDate;
      this.loading = true;
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(
          `${URL}invoice/report/generate?format=${format}&type=${type}`,
          {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify(body),
          }
        );
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        this.download.name = response.nome;
        this.download.link = `${URL}invoice/report/download/${response.nome}`;
        this.linkDownload = true;

        console.log(response);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    getNoteMin(invoice) {
      if (typeof invoice === "undefined") return "";
      if (
        typeof invoice.numbers === "undefined" ||
        invoice.numbers.length === 0
      ) {
        return "";
      }
      return Math.min(...invoice.numbers);
    },
    getNoteMax(invoice) {
      if (typeof invoice === "undefined") return "";
      if (
        typeof invoice.numbers === "undefined" ||
        invoice.numbers.length === 0
      ) {
        return "";
      }
      return Math.max(...invoice.numbers);
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
</style>
<style>
.text-area-uppercase textarea {
  text-transform: uppercase;
}
</style>
